module.exports = __webpack_public_path__ + "img/courseInfo_cover_default.362dc4fe.png";